import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

import { setCompanies } from "src/store/filter";

import { getCompanies } from "src/services/filter";

import Loading from "src/components/common/loading-spinner";
import InnerBox from "components/listing-search/inner-box";
import CheckBoxItem from "src/components/common/checkbox-item";

import styles from "../styles.module.css";

const CompaniesDropDown = ({ criteria }) => {
  const [filter, setFilter] = useState([]);
  const [hasFetchedCompanies, setHasFetchedCompanies] = useState(false);
  const [loading, setLoading] = useState(false);

  const companies = useSelector((state) => state.filter.companies);

  const dispatch = useDispatch();

  const handleCompaniesSelection = (company) => {
    const newSelectedCompanies = [...companies];
    const index = newSelectedCompanies.findIndex((c) => c.id === company.id);

    if (index === -1 && newSelectedCompanies.length < 10) {
      newSelectedCompanies.push(company);
    } else if (index !== -1) {
      newSelectedCompanies.splice(index, 1);
    }

    dispatch(setCompanies(newSelectedCompanies));
  };

  const handleCompaniesFetch = () => {
    if (hasFetchedCompanies) return;

    setLoading(true);
    getCompanies().then((response) => {
      setFilter(response?.data?.companyList);
      setHasFetchedCompanies(true);
      setLoading(false);

      if (criteria?.company?.value.length > 0 && companies?.length === 0) {
        dispatch(
          setCompanies(
            criteria?.company?.value.map((company) => {
              return {
                ...company,
                id: Number(company?.id),
              };
            })
          )
        );
      }
    });
  };

  return (
    <div onClick={handleCompaniesFetch}>
      <InnerBox isDropdownView isHidden={false} title={"Firma Ara"}>
        {loading && <Loading />}
        <section className={styles.checkBoxWrapper}>
          {filter?.map((company, index) => (
            <CheckBoxItem
              key={`${company?.id}+${index}`}
              title={company?.name}
              name={company?.name}
              checkBoxClass={styles.checkBoxClass}
              onChange={() => handleCompaniesSelection(company)}
              checked={companies.some((c) => c?.id === company?.id)}
            />
          ))}
        </section>
      </InnerBox>
    </div>
  );
};

CompaniesDropDown.propTypes = {
  criteria: PropTypes.object,
};

export default CompaniesDropDown;
